export const BASE = {
  company: {
    logo: "https://storage.googleapis.com/companies-assets/arena-fonte-nova/fonte-nova-new-logo.jpg",
    background_image: "https://storage.googleapis.com/companies-assets/fonte-nova/onboarding-fontenova-bg.jpg",
    primaryColor: "#541b10",
    secondaryColor: "#1f1d1d",
    tertiaryColor: "#541b10",
    copyrightLogo: "default",
    backgroundColor: ["#000000", "#000000"],
    tenant: 'fonte-nova-zi56u',
    name: 'Fonte Nova',
    bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
    id: '57e310d5-fcea-42bb-aa80-b8a01a3d8c23',
    dis: 0.87
  }
}